import React from "react";
import PropTypes from "prop-types";
import * as types from "../../constants/ComponentConstants";
import Tooltip from "./Tooltip";

const Section = (props) => {
	let sectionclassName = props.color ? "c-section ia c-section--" + props.color : "c-section ia";
	sectionclassName = props.disabled ? sectionclassName + " disabled" : sectionclassName;
	sectionclassName = props.id ? sectionclassName + " " + props.id : sectionclassName;

	const scrollToTopComponent = props.canScrollToTop ? <i onClick={scrollToTop} className="fa fa-angle-up section--scroll-to-top"></i> : null;
	const style = props.style || {};
	const classes = props.classes || '';

	const tooltip = props.tooltip
		? <Tooltip
			text={props.tooltip}
			tooltipType={types.TOOLTIP_INFO}
			windowWidth={props.tooltipWindowWidth}
			windowAlignRight={props.tooltipWindowAlignRight}
			tooltipColor={props.tooltipColor}
			iconColor={props.iconColor}
		/>
		: null;

	const header = (props.title || props.subtitle) ? (
    <header className="c-section__header">
        {scrollToTopComponent}
        <h3 className="title">
            {props.title}{tooltip}
        </h3>
        {props.subtitle && (
            <h4 className="subtitle">
                {props.subtitle}
            </h4>
        )}
    </header>
) : null;

	function scrollToTop() {
		document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	return (

		<div className="c-section-wrap" style={style}>

			<div className={`${sectionclassName} ${classes}`}>
				{header}
				<div className="c-section__body">
					{props.children}
				</div>
			</div>
		</div>

	);
};

Section.propTypes = {
	iconColor: PropTypes.string,
	title: PropTypes.string,
	subtitle: PropTypes.string,
	style: PropTypes.object,
	color: PropTypes.string,
	children: PropTypes.node,
	disabled: PropTypes.bool,
	tooltipColor: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	canScrollToTop: PropTypes.bool,
	id: PropTypes.string,
	classes: PropTypes.string
};

export default Section;
